import { Badge } from '@ipfabric/ui-components/Badge/Badge';
import { maybeWrapWithTooltip } from '@ipfabric/ui-components/Tooltip/helpers/maybeWrapWithTooltip';
import type { GraphLocationDescriptor } from '@ipfabric/utils';
import { triggerAnalyticsEvent } from 'app/analytics/posthogEvents';
import classNames from 'classnames';
import {
  type MenuTreeNode,
  isGraphLocationDescriptor,
} from 'components/Sidebar/menuTree';
import type { FC } from 'react';
import type { JSX } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigationIncludesCurrentPath } from './utils/navigationIncludesCurrentPath';

interface Props {
  index: number;
  item: MenuTreeNode;
  path: number[];
  compact: boolean;
  url: string | GraphLocationDescriptor;
  label: JSX.Element;
  className?: string;
}

export const NavigationLink: FC<Props> = (props) => {
  const { index, item, url, path, label } = props;

  const currentPath = [...path, index];
  const location = useLocation();

  const handleClick = () => {
    if (isGraphLocationDescriptor(url)) {
      triggerAnalyticsEvent({
        eventName: 'navigation',
        data: {
          type: 'main_menu',
          previous_location: location.pathname,
          new_location: item._key ?? item.label,
          element: 'list_item',
          trigged_by: 'mouse_click',
        },
      });
    }
  };

  return (
    <li key={index} className={props.className}>
      {maybeWrapWithTooltip(
        currentPath.length === 1 && props.compact
          ? {
              content: (
                <>
                  {item.label}
                  {item.preview && (
                    <Badge className='ml-2' color='info'>
                      Beta
                    </Badge>
                  )}
                </>
              ),
              placement: 'right',
            }
          : null,
      )(
        <Link
          className={classNames(
            'navigation__item',
            navigationIncludesCurrentPath(item, location) &&
              'navigation__item--active',
          )}
          {...(isGraphLocationDescriptor(url)
            ? { to: url.to, state: url.state }
            : { to: url })}
          onClick={handleClick}
        >
          {label}
        </Link>,
      )}
    </li>
  );
};
